import React, { useEffect, useState } from "react";
import RenderItemForUserForm from "../components/FormBuilder/subcomponents/form-preview/RederItemForUserForm";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import useModalStrip from "../global-hooks/useModalStrip";
import {
  openCircularProgress,
  closeCircularProgress,
} from "../redux/uireducers/progress";
import { useAppDispatch } from "../redux/hooks";
import Loader from "../utils/Loader";
import Swal from "sweetalert2";
import "./VerifyIdCard.css";
import moment from "moment";
import { FormControlNames } from "../utils/formBuilderUtils";

const VerifyIdcard = ({ }) => {
  const navigate = useNavigate();
  const { formId } = useParams();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const [isConvertingFile, setIsConvertingFile] = useState(false);

  // API URL from environment variables
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // --- State Management ---
  const [componentIndex, setComponentIndex] = useState(0);
  const [formLayoutComponents, setFormLayoutComponents] = useState(
    localStorage.getItem("schoolTemplate")
      ? JSON.parse(localStorage.getItem("schoolTemplate"))
      : { formLayoutComponents: [] },
  );
  const [component, setComponent] = useState(null);
  const [formValues, setFormValues] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [formName, setFormName] = useState(
    formLayoutComponents?.formName || "Verify ID Card",
  );

  // --- Handlers ---

  // Form fields update handler
  const handleChange = (id, value, type) => {
    let processedValue = value;

    if (type === "file" && (value instanceof File || value instanceof Blob)) {
      processedValue = value;
    } else if (type === "date") {
      processedValue = moment(value).format("DD-MM-YYYY");
    }

    setFormValues((prevValues) => ({
      ...prevValues,
      [id]: processedValue,
    }));
  };

  const nextPrevIndex = (val) => {
    setComponentIndex((prev) => prev + val);
  };

  const handleClose = () => {
    navigate(-1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isConvertingFile) {
      return Swal.fire({
        text: "Please wait, image conversion is still in progress.",
        icon: "info",
        confirmButtonText: "Okay",
      });
    }

    const currentFields = component?.children || [];
    for (let element of currentFields) {
      if (element?.required && !formValues[element.id]) {
        return Swal.fire({
          text: `${element?.labelName} is required`,
          icon: "warning",
          confirmButtonText: "Okay",
        });
      }

      if (
        element?.controlName === "mobile-field" &&
        formValues[element.id]?.length !== 10
      ) {
        return Swal.fire({
          text: `${element?.labelName} must be 10 digits`,
          icon: "warning",
          confirmButtonText: "Okay",
        });
      }
    }

    try {
      setIsLoading(true);
      dispatch(openCircularProgress());

      const allFields =
        formLayoutComponents?.formLayoutComponents?.flatMap((comp) => comp.children) || [];

      const result = {};
      const formData = new FormData();
      let isFileUpload = false;

      for (const item of allFields) {
        const value = formValues[item.id];
        if (value == null || value === "") continue;

        const isFileField = [
          FormControlNames.FILEUPLOAD,
          FormControlNames.IMAGEUPLOAD,
          FormControlNames.SCANCODE,
          FormControlNames.CAPTURECLICK,
          FormControlNames.SIGNATURE,
        ].includes(item.controlName);

        if (isFileField) {
          if (value instanceof File) {
            formData.append("imgfiles", value, value.name || `${item.labelName}.jpg`);
            isFileUpload = true;
          } else if (value instanceof Blob) {
            formData.append("imgfiles", value, `${item.labelName}.jpg`);
            isFileUpload = true;
          } else if (typeof value === "string" && value.startsWith("blob:")) {
            const blob = await fetch(value).then((res) => res.blob());
            formData.append("imgfiles", blob, `${item.labelName}.jpg`);
            isFileUpload = true;
          } else if (typeof value === "string" && value.startsWith("data:image/")) {
            const res = await fetch(value);
            const blob = await res.blob();
            formData.append("imgfiles", blob, `${item.labelName}.jpg`);
            isFileUpload = true;
          } else if (typeof value === "string" && /^https?:\/\//.test(value)) {
            // existing uploaded file url, skip
          }

          continue;
        }

        if (item.controlName === FormControlNames.DATEFIELD) {
          result[item.labelName] = moment(
            value,
            ["DD-MM-YYYY", "YYYY-MM-DD", moment.ISO_8601],
            true
          ).format("DD-MM-YYYY");
        } else {
          result[item.labelName] = value;
        }
      }

      const payload = {
        formId,
        userResponseId: searchParams.get("id"),
        resData: result,
        isFileUpload,
      };

      formData.append("mainResponse", JSON.stringify(payload));

      const submitRes = await axios.post(
        `${API_BASE_URL}/user-responses/update`,
        formData
      );

      if (submitRes?.data?.status === "SUCCESS") {
        Swal.fire({ text: submitRes?.data?.message, icon: "success" });
        setFormValues({});
        navigate("/teacher/dashboard");
      } else {
        if (submitRes?.data?.message !== "ONLY_IMAGE_ALLOWED") {
          Swal.fire({
            text: submitRes?.data?.message || "Submission failed",
            icon: "warning",
          });
        }
      }
    } catch (error) {
      console.error("Submit error:", error);
      Swal.fire({ text: "Server error. Please try again.", icon: "error" });
    } finally {
      dispatch(closeCircularProgress());
      setIsLoading(false);
    }
  };


  // async function getUserResponseById() {
  //   try {
  //     setIsLoading(true);
  //     dispatch(openCircularProgress());
  //     const submitRes = await axios.get(
  //       `${API_BASE_URL}/user-responses/${searchParams.get("id")}`,
  //     );
  //     if (submitRes?.data?.status === "SUCCESS") {
  //       // setFormValues(submitRes?.data?.resData);
  //       const student = submitRes?.data?.student;
  //       formLayoutComponents?.formLayoutComponents[
  //         componentIndex
  //       ]?.children.forEach((child) => {
  //         if (student?.resData[child.labelName]) {
  //           if (child.controlName === "date-field") {
  //             console.log("child inside", child);
  //             const splitData = student?.resData[child.labelName]?.split("-");
  //             setFormValues((prevValues) => ({
  //               ...prevValues,
  //               [child.id]: new Date(student?.resData[child.labelName]),
  //             }));
  //           }
  //           setFormValues((prevValues) => ({
  //             ...prevValues,
  //             [child.id]: student?.resData[child.labelName],
  //           }));
  //         }
  //       });
  //     } else {
  //       Swal.fire({
  //         text: submitRes?.data?.message || "Submission failed",
  //         icon: "warning",
  //       });
  //     }
  //   } catch (error) {
  //     Swal.fire({ text: error.message, icon: "error" });
  //   } finally {
  //     dispatch(closeCircularProgress());
  //     setIsLoading(false);
  //   }
  // }

  async function getUserResponseById() {
    try {
      setIsLoading(true);
      dispatch(openCircularProgress());

      const res = await axios.get(
        `${API_BASE_URL}/user-responses/${searchParams.get("id")}`,
      );

      if (res?.data?.status !== "SUCCESS") return;

      const student = res.data.student;
      const updatedValues = {};

      const imageUrl =
        student.uploadImgRes?.length > 0
          ? `${process.env.REACT_APP_IMG_URL}/${student.uploadImgRes[0].fileUrl}`
          : null;

      // ✅ IMPORTANT: iterate ALL steps
      const allFields = formLayoutComponents.formLayoutComponents.flatMap(
        (step) => step.children,
      ) || [];

      allFields.forEach((child) => {
        // ✅ IMAGE FIELD (not in resData)
        console.log("child control name", child.controlName);
        if (child.controlName == FormControlNames.SCANCODE) {
          if (imageUrl) {
            updatedValues[child.id] = imageUrl;
          }
          return;
        }

        const value = student.resData?.[child.labelName];
        if (!value) return;

        // ✅ DATE FIELD (supports all formats)
        if (child.controlName === FormControlNames.DATEFIELD) {
          const parsed = moment(
            value,
            [
              "DD-MM-YYYY",
              "D-MM-YYYY",
              "DD/MM/YYYY",
              "D/M/YYYY",
              "YYYY-MM-DD",
              moment.ISO_8601,
            ],
            true,
          );

          updatedValues[child.id] = parsed.isValid()
            ? parsed.format("DD-MM-YYYY")
            : "";
          return;
        }

        // ✅ NORMAL FIELD
        updatedValues[child.id] = value;
      });

      console.log("HYDRATED VALUES (FINAL)", updatedValues);
      setFormValues(updatedValues);
    } catch (err) {
      Swal.fire({ text: err.message, icon: "error" });
    } finally {
      dispatch(closeCircularProgress());
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (formLayoutComponents?.formLayoutComponents) {
      setComponent(formLayoutComponents.formLayoutComponents[componentIndex]);
    }
  }, [formLayoutComponents, componentIndex]);

  useEffect(() => {
    return () => {
      Object.values(formValues).forEach((value) => {
        if (typeof value === "string" && value.startsWith("blob:")) {
          URL.revokeObjectURL(value);
        }
      });
    };
  }, [formValues]);

  // Update Browser Tab Title
  useEffect(() => {
    document.title = formName;
  }, [formName]);

  useEffect(() => {
    if (formLayoutComponents?.formLayoutComponents?.length) {
      getUserResponseById();
    }
  }, [formLayoutComponents]);

  return (
    <div className="p-30 verify-id-card-container">
      <div className="preview-window mt-2">
        {isLoading && <Loader />}

        <form onSubmit={handleSubmit}>
          {/* Step Progress Header */}
          <div className="step-indicator">
            <div className="step-text d-flex align-items-center justify-content-between">
              <div>
                <span className="step-number">Step {componentIndex + 1}</span>
                <span className="step-total">
                  {" "}
                  of {formLayoutComponents?.formLayoutComponents?.length}
                </span>
              </div>

              {formLayoutComponents?.formLayoutComponents?.length === 1 && (
                <button
                  type="button"
                  className="btn-back"
                  onClick={() => navigate(-1)}
                >
                  ← Back
                </button>
              )}
            </div>
          </div>

          <div className="form-header">
            {formLayoutComponents?.logo && (
              <div className="logo-section">
                <img
                  src={`${process.env.REACT_APP_IMG_URL}/${formLayoutComponents?.logo}`}
                  alt="Logo"
                  className="logo-image"
                />
              </div>
            )}
            <div
              className={`title-section ${formLayoutComponents?.logo ? "left" : "center"}`}
            >
              <h2 className="form-title">{formLayoutComponents?.formName}</h2>
            </div>
          </div>

          <div className="section-heading">
            <h4 className="heading-title">{component?.container?.heading}</h4>
            <p className="heading-subtitle">
              {component?.container?.subHeading}
            </p>
          </div>

          {component?.children?.map((child) => (
            <div key={child.id} className="form-field">
              <label className="field-label">
                {child.labelName}
                {child.required && <span className="required-asterisk">*</span>}
              </label>
              <RenderItemForUserForm
                item={child}
                value={formValues[child?.id]}
                onChange={handleChange}
                isConvertingFile={isConvertingFile}
                setIsConvertingFile={setIsConvertingFile}
              />
            </div>
          ))}

          {/* Navigation Buttons */}
          <div className="button-container d-flex justify-content-between align-items-center mt-4 m-b-100">
            <button
              type="button"
              className={`btn btn-secondary ${componentIndex === 0 ? "disabled" : ""}`}
              disabled={componentIndex === 0}
              onClick={() => nextPrevIndex(-1)}
            >
              ← Back
            </button>


            {componentIndex <
              formLayoutComponents?.formLayoutComponents?.length - 1 ? (
              <button
                type="button"
                className="btn-next btn btn-primary"
                onClick={() => nextPrevIndex(1)}
              >
                Next →
              </button>
            ) : (
              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={handleClose}
                  disabled={isLoading}
                >
                  Close
                </button>

                <button
                  type="submit"
                  className="btn btn-success btn-submit"
                  disabled={isLoading || isConvertingFile}
                >
                  {isLoading ? "Submitting..." : isConvertingFile ? "Converting image..." : "Submit"}
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default VerifyIdcard;
